<template>
  <header class="header">
    <div class="header-box">
      <el-row :class="screen === 'web' ? 'header-container' : 'header-container phone-header-container'">
        <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <div class="header-logo">
            <img @click="() => { $router.push('/'); location.reload(); }" class="logo-image" src="../assets/logo.jpg" />
            <div class="logo-name" @click="() => { $router.push('/'); location.reload(); }">
              <div>{{systemName}}</div>
              <div class="font-title-en">{{systemNameEn}}</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
          <div class="right-container">
             <div class="right-box" @click="playVideo">
              <i class="el-icon-video-camera-solid"></i>
              <div>公司宣传片</div>
            </div>
            <!-- <div class="right-box">
              <i class="el-icon-user-solid"></i>
              <div>加入我们</div>
            </div> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :title="titleName"
      :visible.sync="showModal"
      width="80%"
      :before-close="handleClose">
      <div>
        <video-player
          class="video-player-box"
          ref="videoPlayer"
          :options="playerOptions"
          :playsinline="true"
          customEventName="customstatechangedeventname"
          @play="onPlayerPlay($event)"
          @pause="onPlayerPause($event)"
          @ended="onPlayerEnded($event)"
          @waiting="onPlayerWaiting($event)"
          @playing="onPlayerPlaying($event)"
          @loadeddata="onPlayerLoadeddata($event)"
          @timeupdate="onPlayerTimeupdate($event)"
          @canplay="onPlayerCanplay($event)"
          @canplaythrough="onPlayerCanplaythrough($event)"
          @statechanged="playerStateChanged($event)"
          @ready="playerReadied">
        </video-player>
      </div>
    </el-dialog>
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
   export default {
    name: 'Header',
    data() {
      return {
        userInfo: {},
        showModal: false,
        titleName: '公司宣传片',
        playerOptions: {
          // videojs options
          muted: false,
          language: 'en',
          playbackRates: [0.7, 1.0, 1.5, 2.0],
          sources: [{
            type: "video/mp4",
            src: "http://static.njxianhe.com/video/douying.mp4"
          }],
          poster: "http://static.njxianhe.com/img/author.png",
        }
      }
    },
    computed: {
       ...mapGetters([
        "systemName",
        "systemNameEn",
        "screen"
      ]),
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    mounted() {
      this.userInfo = JSON.parse(localStorage.getItem("XXXUserInfo"));
    },
     methods: {
       ...mapActions([
         "logout"
       ]),
       signOut() {
         localStorage.removeItem("XXXUserInfo");
         localStorage.removeItem("XXXUserToken");
         this.$store.commit('userInfoMutation', {});
         this.$router.push({ path: '/login' }); 
       },
       playVideo () {
         this.showModal = true;
       },
       handleClose () {
         this.showModal = false;
       },
      onPlayerPlay(player) {
        // console.log('player play!', player)
      },
       onPlayerPause(player) {
        console.log('player pause!', player)
        player.off();
      },
      onPlayerEnded(player) {
        // console.log('player pause!', player)
      },
      onPlayerWaiting(player) {
        // console.log('player pause!', player)
      },
      onPlayerPlaying(player) {
        // console.log('player pause!', player)
      },
      onPlayerLoadeddata(player) {
        // console.log('player pause!', player)
      },
      onPlayerTimeupdate(player) {
        // console.log('player pause!', player)
      },
       onPlayerCanplay(player) {
        // console.log('player pause!', player)
      },
       onPlayerCanplaythrough(player) {
        // console.log('player pause!', player)
      },
       playerStateChanged(playerCurrentState) {
        // console.log('player current update state', playerCurrentState)
      },
      playerReadied(player) {
        console.log('the player is readied', player)
        // you can use it to do something...
        // player.[methods]
      }
     }
  }

</script>

<style lang="less" scoped>
.header {
  box-shadow: 0 2px 10px 0 rgb(0, 0, 0, 0.4);
  .video-player-box {
    padding-bottom: 0.4rem;
  }
  .header-box{
    .phone-header-container {
       padding: 0.14rem 0.1rem !important;
    }
    .header-container {
      margin: 0 auto;
      background: #fff;
      padding: 0.14rem 7.5%;
      // background: #3a79ff;
      .header-logo {
        font-weight: 700;
        color: #000;
        font-size: 0.32rem;
        display: flex;
        align-items: center;
      }
      .logo-image {
        width: 1rem;
        padding-right: 0.2rem;
        cursor: pointer;
      }
      .logo-name {
        cursor: pointer;
      }
      .font-title-en {
        font-size: 0.18rem;
      }
      .right-container {
        display: flex;
        justify-content: flex-end;
        padding: 0.1rem;
        .right-box {
          font-size: 0.2rem;
          display: flex;
          flex-direction: column;
          text-align: center;
          cursor: pointer;
          margin-left: 16px;
          color: #409EFF;
          i {
            font-size: 0.4rem;
          }
        }
      }
    }
  }
}
</style>
